import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

// Global fetch wrapper to specify database tenant for the shared backend server
const originalFetch = window.fetch;
window.fetch = async function (url, options = {}) {
  const headers = options.headers ? { ...options.headers } : {};
  // Only add the tenant header for API requests
  if (typeof url === 'string' && (url.includes('/api/') || url.includes('/api') || url.includes('localhost:5001'))) {
    headers['x-database-name'] = 'multicarewards2';
  }
  options.headers = headers;
  return originalFetch(url, options);
};

// Simple error handler
Vue.config.errorHandler = function (err, vm, info) {
  console.error('Vue Error:', err, info)
  // Don't auto-reload to prevent infinite loops
  // Only reload if it's a critical error and not in development
  if (process.env.NODE_ENV === 'production' && err.name === 'ChunkLoadError') {
    console.warn('Chunk load error detected, reloading...')
    window.location.reload()
  }
}

// Handle page titles and meta tags
router.beforeEach((to, from, next) => {
  // Update page title
  document.title = to.meta.title || 'Sunway Multicare Pharmacy Top Choice Awards 2026'

  // Update meta description
  let metaDescription = document.querySelector('meta[name="description"]')
  if (!metaDescription) {
    metaDescription = document.createElement('meta')
    metaDescription.name = 'description'
    document.head.appendChild(metaDescription)
  }
  metaDescription.content = to.meta.description || 'Participate in Sunway Multicare Pharmacy Top Choice Awards 2026 and win exciting prizes!'

  next()
})

// Simple app creation
new Vue({
  router,
  vuetify,
  render: h => h(App),
  mounted() {
    // Remove loading screen
    const loading = document.getElementById('loading-fallback')
    if (loading) loading.remove()
  }
}).$mount('#app')
